



















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import Question from '@/competences/entities/question'
import Competence from '@/competences/entities/competence'

@Component
export default class QuestionsList extends Vue {
  @Prop({ default: () => [] })
  public value!: Question[]

  @Prop({ default: false })
  public readonly!: boolean

  private questions = this.value

  private newText = ''

  private newQuestion() {
    if (this.newText.length > 0) {
      var question = new Question()
      question.text = this.newText
      question.sortIndex = this.value.length
      this.questions.push(question)
      this.$emit('create', question)
      this.newText = ''
    }
  }

  private mounted() {
    this.questions = this.value
  }
}
